import React, { useContext } from "react";
import { Selectbox, Wrapper } from "./style";
import { LanguageContext } from "../../core/store";
import { LanguageConfig } from "../../languages";

const LanguageChanger = () => {

    const { currentLanguage, handleLanguageChange } = useContext(LanguageContext);

    return (
        <Wrapper>
            <Selectbox value={currentLanguage} onChange={handleLanguageChange}>
                {LanguageConfig?.options?.map((language) => {
                    return <option key={language?.value} value={language?.value}>{language?.label}</option>;
                })}
            </Selectbox>
        </Wrapper>
    );
};

export default LanguageChanger;
